module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-CLASSMATES.bb4f1ee1.png";